// this should go into some "Modules" folder, but I didn't want to confuse you even more.

export default class VideoRecorder {
  public media: MediaRecorder | null;

  private fileName: string;

  private options?: FilePropertyBag | undefined;

  private onBlobReadyCallback: (chunks: Blob[]) => void;

  private onVideoReadyCallback: (file: File) => void;

  public mediaAttached: (media: MediaRecorder) => void;

  constructor() {
    this.media = null;
    this.fileName = 'video.webm';
    this.options = { type: 'video/webm;codecs=vp8' };
    this.onBlobReadyCallback = () => {};
    this.onVideoReadyCallback = () => {};
    this.mediaAttached = () => {};
  }

  setStream(stream: MediaStream) {
    const isFirefox = navigator.userAgent.search('Firefox') !== -1;
    this.media = new MediaRecorder(stream, { mimeType: isFirefox ? 'video/webm' : 'video/webm;codecs=vp8' });
    this.mediaAttached(this.media); // for state
    this.media.addEventListener('stop', () => {
      stream.getTracks().forEach((track) => {
        // for stopping the camera access
        track.stop();
      });
    });

    this.media.addEventListener('dataavailable', (e: any) => {
      if (e.data.size > 0) {
        // put this into array if we are going to include pause button in the future
        this.onBlobReadyCallback([e.data]);

        // for video callback
        const videoFile = new File([e.data], this.fileName, this.options);
        this.onVideoReadyCallback(videoFile);
      }
    });
  }

  onBlobReady(cb: (chunks: Blob[]) => void) {
    this.onBlobReadyCallback = cb;
  }

  onVideoReady(cb: (file: File) => void, fileName?: string, options?: FilePropertyBag) {
    this.onVideoReadyCallback = cb;
    if (fileName) this.fileName = fileName;
    if (options) this.options = options;
  }

  startRecording() {
    if (this.media) {
      this.media.start();
    }
  }

  stopRecording() {
    if (this.media) {
      this.media.stop();
    }
  }
}
